export default {
	computed: {
		cSpoConfig() {
			const configs = this.$srv('ShopProductOptions')
			if (!this.product || !configs?.length) return null
			for (const config of configs) {
				if (!config.collectionId) return config
				if (this.product.collectionsIds.some((id) => id == config.collectionId)) {
					return config
				}
			}
			return null
		},
		spoHideBuyBtn() {
			return this.cSpoConfig?.hideBuyBtn
		},
		spoHideDiscount() {
			return this.cSpoConfig?.hideDiscount
		},
		spoHidePrevPrice() {
			return this.cSpoConfig?.hidePrevPrice
		},
		spoHidePrice() {
			return this.cSpoConfig?.hidePrice
		},
		spoHideAllPrice() {
			return this.spoHideDiscount && this.spoHidePrevPrice && this.spoHidePrice
		},
		spoHideQtyInput() {
			return this.cSpoConfig?.hideQtyInput
		},
		hideCalculatedPrice() {
			return this.cSpoConfig?.hideCalculatedPrice
		},
		spoHideBrand() {
			return this.cSpoConfig?.hideBrand
		},
		spoHideSku() {
			return this.cSpoConfig?.hideSku
		},
		spoHideEan() {
			return this.cSpoConfig?.hideEan
		},
		spoHideSeller() {
			return this.cSpoConfig?.hideSeller
		},
	},
}

